import { useState, useEffect } from 'react';
import api from "../../axiosConfig"; // ✅ Ruta correcta confirmada

const useEstadisticas = () => {
  const [estadisticas, setEstadisticas] = useState({
    periodoActual: {
      EstanciaI: 0,
      EstanciaII: 0,
      Estadia: 0,
      ServicioSocial: 0,
      EstadiaNacional: 0,
    },
    globales: {
      totalUsuarios: 0,
      EstanciaI: 0,
      EstanciaII: 0,
      Estadia: 0,
      ServicioSocial: 0,
      EstadiaNacional: 0,
    },
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const normalizeTipo = (value) =>
    (value ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();

  useEffect(() => {
    const fetchEstadisticas = async () => {
      setLoading(true);
      setError(null);
      try {
        // ✅ Obtener periodo activo
        const { data: periodos } = await api.get('/periodos');
        const periodoActivo = periodos.find((p) => p.EstadoActivo === 'Activo');
        
        if (!periodoActivo) {
          throw new Error('No hay periodo activo');
        }

        // ✅ Obtener procesos
        const { data: procesos } = await api.get('/procesos');

        // ✅ Obtener total de usuarios
        const { data: estudiantes } = await api.get('/estudiantes');

        // 📊 Calcular estadísticas
        const tipoToClave = {
          [normalizeTipo('Estancia I')]: 'EstanciaI',
          [normalizeTipo('Estancia II')]: 'EstanciaII',
          [normalizeTipo('Estadía')]: 'Estadia',
          [normalizeTipo('Servicio Social')]: 'ServicioSocial',
          [normalizeTipo('Estadía Nacional')]: 'EstadiaNacional',
        };

        const periodoActual = {
          EstanciaI: 0,
          EstanciaII: 0,
          Estadia: 0,
          ServicioSocial: 0,
          EstadiaNacional: 0,
        };

        const globales = {
          totalUsuarios: estudiantes.length,
          EstanciaI: 0,
          EstanciaII: 0,
          Estadia: 0,
          ServicioSocial: 0,
          EstadiaNacional: 0,
        };

        // 🔢 Contar procesos por tipo
        procesos.forEach((proceso) => {
          const clave = tipoToClave[normalizeTipo(proceso?.tipo_proceso)];
          if (clave) {

            // Incrementar contador global
            if (globales.hasOwnProperty(clave)) {
              globales[clave] += 1;
            }

            // Incrementar contador del periodo actual
            const idPeriodoProc = Number(proceso.id_periodo);
            const idPeriodoActivo = Number(periodoActivo.IdPeriodo);
            
            if (idPeriodoProc === idPeriodoActivo && periodoActual.hasOwnProperty(clave)) {
              periodoActual[clave] += 1;
            }
          }
        });

        setEstadisticas({ periodoActual, globales });
        
      } catch (err) {
        const mensaje = err.response?.data?.error || err.message || 'Error al obtener estadísticas';
        setError(mensaje);
        console.error('Error fetchEstadisticas:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchEstadisticas();
  }, []);

  return { estadisticas, loading, error };
};

export default useEstadisticas;
